import SentimentSummaryShort from "./SentimentSummaryShort";

export default SentimentSummaryShort;
